module.exports = __webpack_public_path__ + "static/procesProdukcjaDesktop@x2-9974e6d93c9a18e1d40dc0a4ddc3e8a2.png";